import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/lib/auth';
export default function AccountAdmin() {
  const { user } = useAuth();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  async function save(e) {
    e.preventDefault(); setMessage('');
    if (password !== repeat) {setMessage('Las contraseñas nuevas no coinciden.'); return;}
    if (password.length < 12) {setMessage('Usa al menos 12 caracteres.'); return;}
    if (password === current) {setMessage('Elige una contraseña distinta de la actual.'); return;}
    setBusy(true);
    try {
      const verified = await supabase.auth.signInWithPassword({email:user.email, password:current});
      if (verified.error) throw new Error('La contraseña actual no es correcta.');
      const {error} = await supabase.auth.updateUser({password});
      if (error) throw error;
      setCurrent(''); setPassword(''); setRepeat('');
      setMessage('Contraseña actualizada. Utiliza la nueva contraseña en tu próximo inicio de sesión.');
    } catch (error) {setMessage(error.message);}
    finally {setBusy(false);}
  }
  return <section className="bg-white border-2 border-slate-950 p-6 max-w-xl">
    <h2 className="font-display text-2xl font-bold uppercase">Mi cuenta</h2><p className="text-sm text-slate-500 mt-2">{user.email}</p>
    <form onSubmit={save} className="space-y-4 mt-6">
      <label className="block text-sm">Contraseña actual<input type="password" autoComplete="current-password" required value={current} onChange={e=>setCurrent(e.target.value)} className="block border p-3 mt-1 w-full"/></label>
      <label className="block text-sm">Nueva contraseña<input type="password" autoComplete="new-password" required minLength={12} value={password} onChange={e=>setPassword(e.target.value)} className="block border p-3 mt-1 w-full"/></label>
      <label className="block text-sm">Repetir nueva contraseña<input type="password" autoComplete="new-password" required minLength={12} value={repeat} onChange={e=>setRepeat(e.target.value)} className="block border p-3 mt-1 w-full"/></label>
      <p className="text-xs text-slate-500">Usa al menos 12 caracteres y una contraseña que no uses en otros sitios.</p>
      {message && <p role="status" className="text-sm">{message}</p>}
      <button disabled={busy} className="bg-amber-500 p-3 font-display font-bold uppercase disabled:opacity-50">{busy?'Guardando…':'Cambiar contraseña'}</button>
    </form>
  </section>;
}
